import React from 'react';
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from '../customerGroupSetupSlice';

const alertFontSize = "15px";

export default function Popup() {
   const dispatch = useDispatch();
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { popUpMsg, popUpSeverity, popUpOpen } = cgState;

   function handleClose() {
      dispatch(setCGState("popUpOpen", false));
   }

   return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={popUpOpen}
			autoHideDuration={5000}
			onClose={handleClose}
		>
			<Alert
				onClose={handleClose}
				severity={popUpSeverity}
				sx={{ width: "100%", fontSize: alertFontSize }}
			>
				{popUpMsg}
			</Alert>
		</Snackbar>
	);
}
